import { render, staticRenderFns } from "./AssetCategory.vue?vue&type=template&id=30caef08&scoped=true"
import script from "./AssetCategory.vue?vue&type=script&lang=js"
export * from "./AssetCategory.vue?vue&type=script&lang=js"
import style0 from "./AssetCategory.vue?vue&type=style&index=0&id=30caef08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30caef08",
  null
  
)

export default component.exports